import React from 'react';
import classNames from 'classnames';
import { ErrorBoundary } from '../ErrorBoundary';
import { TabsRole } from './const';
import classes from './styles/tab.module.scss';
import { TabComponent, TabId } from './types';
import { useTabsWrapperProvider } from './Tabs';
import { getTabId, getTabPanelId } from './utils';
import { isPositiveInteger } from '../../utils/number';
import { Counter } from '../Counter';

export type TabProps = {
	id: TabId;
	dataTestId?: string;
	className?: string;
	counter?: number | null;
	counterTestId?: string;
	disabled?: boolean;
	transparentActiveTab?: boolean;
};

/**
 * Tab button
 * Must be a child of TabList component
 */
export const Tab: TabComponent<TabProps> = ({
	id,
	dataTestId,
	className,
	counter,
	disabled,
	transparentActiveTab,
	children,
}) => {
	const { activeTab } = useTabsWrapperProvider();
	const selected = id === activeTab;
	const componentClasses = classNames(classes.tab, className, {
		[classes.tab_transparent]: transparentActiveTab,
	});

	return (
		<ErrorBoundary>
			<button
				id={getTabId(id)}
				data-testid={dataTestId}
				className={componentClasses}
				tabIndex={selected ? 0 : -1}
				role='tab'
				aria-selected={selected}
				aria-controls={getTabPanelId(id)}
				disabled={disabled}
				type='button'
			>
				{children}
				{isPositiveInteger(counter) && (
					<Counter
						gray
						className={classes.counter}
					>
						{counter}
					</Counter>
				)}
			</button>
		</ErrorBoundary>
	);
};

Tab.tabsRole = TabsRole.Tab;
